import { CONFIG } from "../../appConfig";

export default {
  /**
   * @desc Get the dictionary list based on locale, it also can be used to get the dictionary version with versionOnly parameter
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.dynamic
   * @example
   * const data = {
   *    params: {
   *        versionOnly *(Boolean)*
   *    }
   * }
   * services.gma.dynamic.getDynamicContent();
   * update session with the response
   */
  getDynamicContent(data = {}) {
    const { params = {} } = data;

    const channel = String(CONFIG.CHANNEL).toLowerCase();

    return {
      method: "GET",
      origin: CONFIG.DYNAMIC_CONTENT_ORIGIN_URL,
      endpoint: `${channel}/dictionary/${CONFIG.LOCALE}`,
      headers: {
        domain_country_of_residence: CONFIG.COUNTRY,
      },
      params,
    };
  },
};
